module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/logo-guard-text.6213dc6b.png";